import React, { useState, useCallback } from 'react';
import EDMiniDrawer from '../../../../../../../BaseComponents/Drawers/MiniDrawer/EDMiniDrawer';
import EDList from '../../../../../../../BaseComponents/List/EDList';
import EkonomiskAnalysExpandableListItem from '../../../EkonomiskAnalys/Components/SideMenu/Components/ListItems/EkonomiskAnalysExpandableListItem';
import AnalysUtdelningFiltering from './Components/AnalysUtdelningFiltering/AnalysUtdelningFiltering';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';

interface IProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  showAvailable: boolean;
  showNotAvailable: boolean;
  setShowAvailable: (available: boolean) => void;
  setShowNotAvailable: (available: boolean) => void;
  showVisible: boolean;
  showNotVisible: boolean;
  setShowVisible: (visible: boolean) => void;
  setShowNotVisible: (visible: boolean) => void;
}

/**
 * Sidomenyn för analysutdelningsrutinen med inställningar för den
 */
const AnalysUtdelningSideMenu: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    open,
    setOpen,
    showAvailable,
    showNotAvailable,
    setShowAvailable,
    setShowNotAvailable,
    showVisible,
    showNotVisible,
    setShowVisible,
    setShowNotVisible,
  } = props;

  const [optionsOpen, setOptionsOpen] = useState(false);

  const onOptionsClick = useCallback(() => {
    if (!open) {
      setOpen(true);
    }

    setOptionsOpen(!optionsOpen);
  }, [open, optionsOpen, setOpen]);

  return (
    <EDMiniDrawer
      open={open}
      close={() => setOpen(false)}
      toolbar={
        <div>
          <EDIconButton
            tooltip={open ? 'Stäng' : 'Öppna'}
            icon={open ? 'chevron_left' : 'chevron_right'}
            onClick={() => {
              if (open) {
                setOptionsOpen(false);
              }
              setOpen(!open);
            }}
          />
        </div>
      }
      hideToolbarDivider
    >
      <EDList>
        <EkonomiskAnalysExpandableListItem
          open={optionsOpen}
          text="Urval"
          iconType="filter_list"
          sideMenuOpen={open}
          openSideMenu={onOptionsClick}
          toggleOpen={onOptionsClick}
        >
          <AnalysUtdelningFiltering
            showAvailable={showAvailable}
            showNotAvailable={showNotAvailable}
            setShowAvailable={setShowAvailable}
            setShowNotAvailable={setShowNotAvailable}
            showVisible={showVisible}
            showNotVisible={showNotVisible}
            setShowVisible={setShowVisible}
            setShowNotVisible={setShowNotVisible}
          />
        </EkonomiskAnalysExpandableListItem>
      </EDList>
    </EDMiniDrawer>
  );
};

export default AnalysUtdelningSideMenu;
